<template>

<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20 17H77V82H42.4789H38.0634H33.6479H20V17Z" stroke="black" stroke-width="4"/>
<path d="M27 38H70" stroke="black" stroke-width="4"/>
<path d="M27 49H57" stroke="black" stroke-width="4"/>
<path d="M27 60H44" stroke="black" stroke-width="4"/>
</svg>

</template>
